var _rect, _path, _rect2, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 14,
    fill: "#F2F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5968 65.0184H45.7784V56.1273H85.7538V65.0184H70.9353V105.338H60.5968V65.0184ZM92.2729 76.8731H86.6212V69.3605H92.2729V59.7802H101.922V69.3605H110.193V76.8731H101.922V93.4836C101.922 95.3675 102.313 96.6541 103.094 97.3433C103.875 97.9866 104.886 98.3082 106.126 98.3082C106.77 98.3082 107.413 98.2852 108.056 98.2393C108.746 98.1474 109.412 98.0096 110.055 97.8258L111.434 104.925C110.101 105.338 108.791 105.614 107.505 105.752C106.264 105.936 105.07 106.028 103.921 106.028C99.9693 106.028 97.0286 105.086 95.0988 103.202C93.2149 101.318 92.2729 98.1474 92.2729 93.6904V76.8731Z",
    fill: "#2E3A59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3229,
    y: 31.3231,
    width: 97.3538,
    height: 97.3538,
    stroke: "#2E3A59",
    strokeWidth: 0.861538,
    strokeDasharray: "5.17 5.17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8923,
    cy: 30.8923,
    r: 6.89231,
    fill: "#2E3A59"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8923,
    cy: 129.108,
    r: 6.89231,
    fill: "#2E3A59"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.108,
    cy: 30.8923,
    r: 6.89231,
    fill: "#2E3A59"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.108,
    cy: 129.108,
    r: 6.89231,
    fill: "#2E3A59"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.d7f71c24.svg";
export { ForwardRef as ReactComponent };